import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
`;